export default {
	NONE: 'none',
	REGULAR: 'regular',
	FIRST_LESSON: 'first_lesson',
	GOOGLE_SLIDES_CANNOT_COPY_PASTE_SLIDES: 'tooltipGSCannotCopyAndPasteSlides',
	NICKEL_TOUR: 'tooltipNickelTour',
	STUDENT_PACED_LAUNCHED_WITH_COLLABORATE: 'tooltipStudentPacedLaunchedWithCollaborate',
	INTERACTIVE_VIDEO_WELCOME_MODAL: 'tooltipInteractiveVideoWelcomeModal',
	INTERACTIVE_VIDEO_EDITOR_WELCOME_TOUR_MODAL: 'tooltipInteractiveVideoEditorWelcomeTourModal',
	INTERACTIVE_VIDEO_EDITOR_WELCOME_TOUR_STEP_1: 'tooltipInteractiveVideoEditorWelcomeTourStep1',
	INTERACTIVE_VIDEO_EDITOR_WELCOME_TOUR_STEP_2: 'tooltipInteractiveVideoEditorWelcomeTourStep2',
	INTERACTIVE_VIDEO_EDITOR_WELCOME_TOUR_STEP_3: 'tooltipInteractiveVideoEditorWelcomeTourStep3',
	INTERACTIVE_VIDEO_EDITOR_WILL_TRIM_ACTIVITIES: 'tooltipInteractiveVideoEditorWillTrimActivities',
	INTERACTIVE_VIDEO_CHECK_PROGRESS: 'tooltipInteractiveVideoCheckProgress',
}
